import type * as ScheduledPayment from './scheduledPayment';

export type Entity = Partial<ScheduledPayment.Entity>;

export const create = (draftScheduledPayment?: Entity): Entity => ({
  id: draftScheduledPayment?.id,
  amount: draftScheduledPayment?.amount,
  date: draftScheduledPayment?.date,
});
